import { createAction } from '@reduxjs/toolkit';
import { stateName } from '../constants';
export const fetchCountryBoundsRequest = createAction("".concat(stateName, "/fetchCountryBoundsRequest"));
export const fetchNearbyPointsByElementRequest = createAction("".concat(stateName, "/handlePickupModalElementRequest"));
export const trackShippingPointsLoad = createAction("".concat(stateName, "/trackShippingPointsLoad"));
export const fetchNearbyShippingOptionsRequest = createAction("".concat(stateName, "/fetchNearbyShippingOptionsRequest"));